var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "jade-button-group" }, [
    _c(
      "div",
      { staticClass: "jade-button-group__desktop", class: _vm.computedClass },
      [_vm._t("default", null, { size: "medium" })],
      2
    ),
    _c(
      "div",
      { staticClass: "jade-button-group__mobile", class: _vm.computedClass },
      [_vm._t("default", null, { size: "larger" })],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }